module.exports = __webpack_public_path__ + "assets/img/img_btbj.ea88fb16.png";